module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-content l-document"
  }, [_c('custom-toolbar', {
    attrs: {
      "backLabel": "Retour"
    }
  }, [_vm._v(_vm._s(_vm.$t("Brochures")))]), _vm._v(" "), _c('v-ons-list', _vm._l((_vm.brochures), function(brochure, index) {
    return _c('v-ons-list-item', {
      key: index,
      attrs: {
        "tappable": ""
      },
      on: {
        "click": function($event) {
          return _vm.view(brochure)
        }
      }
    }, [_c('div', {
      staticClass: "center"
    }, [_vm._v(_vm._s(brochure.title))]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('v-ons-button', [_c('i', {
      staticClass: "fas fa-eye"
    })])], 1)])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-390e9e97","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/KeyholdingBrochures.vue
// module id = 205
// module chunks = 0